<template>
  <component
    :is="varComp"
    :hover="hovering"
    variant=""
    :resource="resource"
    :pdfInfo="pdfInfo"
  ></component>
</template>

<script>
import PdfFull from './PdfFull';
import PdfFooter from './PdfFooter';
import PdfListItem from './PdfListItem';

export default {
  components: { PdfFull, PdfListItem, PdfFooter },
  props: {
    hovering: {},
    blockData: {
      default: () => ({
        resource: {},
        excerpts: []
      })
    },
    blockType: {},
    variant: {}
  },
  data() {
    return {
      comps: {
        full: PdfFull,
        footer: PdfFooter,
        listItem: PdfListItem
      }
    }
  },
  computed: {
    varComp() {
      return this.comps[this.variant];
    },
    resource() {
      return this.blockData.resource;
    },
    pdfInfo() {
      return this.blockData.resource ? this.blockData.resource.resourceData : {};
    }
  }
};
</script>
